import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from 'src/app/user.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { saveAs } from 'file-saver';
// import * as saveAs from 'file-saver';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from "ngx-spinner";
import { JsonPipe } from '@angular/common';
import { UserHeaderComponent } from '../user-header/user-header.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent implements OnInit {
  // public s3Url = "https://evolvetax.s3.ap-south-1.amazonaws.com/fileUpload/"; 
  config: any;
  ID: any;
  public data: any = [];
  public selectedYear: any;
  p: number = 1;
  uploadListData: any;
  ramki: string[];
  fileName: string;
  ramkiNew: any;
  newFileNo: any;
  constructor(private httpClient: HttpClient,
    public usr: UserService,
    public toastr: ToastrService,
    private SpinnerService: NgxSpinnerService) {
    let b = JSON.parse(localStorage.getItem('data'));
    this.ramkiNew = b;
  }

  ngOnInit(): void {
    this.config = {
      itemsPerPage: 5,
      currentPage: 1
    }
    this.ID = JSON.parse(localStorage.getItem('data'));
    this.data = JSON.parse(localStorage.getItem('years'));
    let obj = {
      'user_id': this.ID.user_id,
      'year': this.data[0],
    }
    this.SpinnerService.show();
    this.usr.years(obj).subscribe((res: any) => {
      if (res.code === 200) {
        this.SpinnerService.hide();
        this.uploadListData = res.data;
        if (this.uploadListData.length > 0) {
          let c = this.uploadListData[this.uploadListData.length - 1];
          this.newFileNo = c.fileNo;
          localStorage.setItem('newFileNo',this.newFileNo);
          console.log(this.newFileNo);
          if (c.fileNo) {
            this.usr.fileNum.next(c.fileNo);
          }
        }

      } else {
        this.SpinnerService.hide();
        this.toastr.error(res.message);
      }
    }, (err) => {
      this.SpinnerService.hide();
      this.toastr.error(err);
    })
  }

  pageChanged(event) {
    this.config.currentPage = event;
  }

  onOptionsSelected(value: string) {
    let obj = {
      'user_id': this.ID.user_id,
      'year': value
    }
    this.usr.years(obj).subscribe((res: any) => {
      // this.data = res.data;
      if (res.code === 200) {
        localStorage.setItem('newYear', obj.year);
        this.uploadListData = res.data;
        this.toastr.success("Data Updated");
      } else {
        this.toastr.error(res.message);
      }
    },
      (err) => {
        this.toastr.error(err);
      });
  }

  downloadFile(files: any) {
    // files = files.split(this.s3Url);
    // files = this.s3Url;
    let baseUrl = "https://9h6bwbaajf.execute-api.ap-south-1.amazonaws.com/dev/";
    // let baseUrl = "http://192.168.1.104:2528/";
    let obj = {
      "user_id": this.ID.user_id,
      "file_name": files
    }
    // this.httpClient.post(baseUrl + "fileDownload",obj, { responseType: 'blob' }).subscribe(blob => {
    this.httpClient.post(baseUrl + "fileDownload", obj).subscribe((res: any) => {
      if (res.code === 200) {
        this.toastr.success(res.message);
      } else {
        this.toastr.error(res.message);
      }
    }, (err => console.error('er', err)))
  }
} 